/* eslint-disable jsx-a11y/anchor-is-valid */
import { useActivation } from '@context/MobileOne';
import { ButtonPrimary, DuetDatePicker, FocusFirstError, FormDatePicker, FormInputField, ScrollToTop } from '@core/index';
import Icons from '@core/Utils/Icons/Icons';
import { AppPageContentWrapper } from '@part/AppPageContentWrapper';
import { tA11y } from '@utils/a11y/a11yHelpers';
import { sanitizeRichText } from '@utils/sanitizeHtml';
import { appButtonType, appIcons, appIconsPath, validCharRegex } from '@utils/globalConstant';
import { Form, Formik } from 'formik';
import moment from 'moment';

export function EditPrivateData() {
  // Contexts
  const { setPersonalDataForm, personalDataForm, personalDataValidations, setStep9SubStep } =
    useActivation();

  // const
  const headerContent = tA11y('ek_reg_change_pers_data_hdl1');
  const buttonContent = tA11y('ek_reg_change_btn1');
  const editPrivateDataSchema = personalDataValidations.pick(['firstName', 'lastName', 'birthDate']);
  const today = new Date();
  const minDate = new Date(today.setFullYear(today.getFullYear() - 16));
  const minDateString = minDate.toISOString().split('T')[0];

  // Function
  const onBackClick = () => {
    setStep9SubStep(0);
  };
  return (
    <>
      <ScrollToTop>
        <div className="min-dvh-100">
          <AppPageContentWrapper>
            <div className="mnp-activation w-100">
              <button
                type="button"
                className="border-0 bg-transparent m-0 p-0 mb-32"
                aria-label={tA11y('ek_global_icn-back_aria').ariaLabel}
                onClick={onBackClick}>
                <Icons name="ARROW_BACK" height={24} colorType="dark" />
              </button>

              {headerContent?.content !== '' && headerContent?.content !== undefined && (
                <>
                  {headerContent?.isHtml ? (
                    <h2
                      className="ek-h2 text-primary mb-40"
                      dangerouslySetInnerHTML={{ __html: sanitizeRichText(headerContent?.content) }}
                    />
                  ) : (
                    <h2 className="ek-h2 text-primary mb-40">{headerContent?.content}</h2>
                  )}
                </>
              )}

              <Formik
                initialValues={personalDataForm}
                validationSchema={editPrivateDataSchema}
                onSubmit={(val) => {
                  setPersonalDataForm({ ...personalDataForm, ...val });
                  setStep9SubStep(0);
                }}>
                {({
                  values: { firstName, lastName, birthDate },
                  handleBlur,
                  handleChange,
                  handleSubmit,
                  setFieldValue,
                  touched,
                  errors
                }) => (
                  <Form onSubmit={handleSubmit}>
                    <FormInputField
                      label="ek_global_name_lbl"
                      placeholder="ek_global_name_plc"
                      // hint="ek_global_name_info"
                      type="text"
                      id="firstName"
                      name="firstName"
                      value={firstName}
                      onChange={handleChange}
                      onClear={setFieldValue}
                      onBlur={handleBlur}
                      valid={touched.firstName && !errors.firstName}
                      invalid={touched.firstName && errors.firstName}
                      invalidMessage={
                        touched.firstName && errors.firstName ? errors.firstName : null
                      }
                      aria-describedby="firstName-error"
                      checkCharRegex={validCharRegex.FIRST_NAME}
                    />
                    <FormInputField
                      customClass="mt-32 mb-32"
                      label="ek_global_surname_lbl"
                      placeholder="ek_global_surname_plc"
                      // hint="ek_global_surname_info"
                      type="text"
                      id="lastName"
                      name="lastName"
                      value={lastName}
                      onChange={handleChange}
                      onClear={setFieldValue}
                      onBlur={handleBlur}
                      valid={touched.lastName && !errors.lastName}
                      invalid={touched.lastName && errors.lastName}
                      invalidMessage={touched.lastName && errors.lastName ? errors.lastName : null}
                      aria-describedby="lastName-error"
                      checkCharRegex={validCharRegex.LAST_NAME}
                    />
                    {/* <FormDatePicker
                      id="id"
                      value={birthDate}
                      name="birthDate"
                      label="ek_global_brthdy_lbl"
                      placeholder="ek_global_brthdy_plc"
                      // hint="ek_global_brthdy_info"
                      onChange={(date) => setFieldValue('birthDate', date)}
                      onBlur={handleBlur}
                      valid={touched.birthDate && !errors.birthDate}
                      invalid={touched.birthDate && errors.birthDate}
                      invalidMessage={
                        touched.birthDate && errors.birthDate ? errors.birthDate : null
                      }
                      aria-describedby="birthDate-error"
                    /> */}
                    <DuetDatePicker
                      value={birthDate}
                      onChange={(e) => {
                        setFieldValue('birthDate', moment(e.detail.valueAsDate).format('DD.MM.YYYY'))
                      }}
                      label={'ek_global_brthdy_lbl'}
                      id="birthDate"
                      name="birthDate"
                      min="1900-01-01"
                      max={`${minDateString}`}
                      placeholder={'ek_global_brthdy_plc'}
                      ariaDescribedby="birthDate-error"
                      onBlur={handleBlur}
                      valid={touched.birthDate && !errors.birthDate}
                      invalid={!!touched.birthDate && !!errors.birthDate}
                      invalidMessage={
                        touched.birthDate && errors.birthDate ? errors.birthDate : null
                      }
                      identifier="birthDate-input"
                    />
                    <div className="row">
                      <div className="col-xxl-5 col-lg-5 col-10 px-0 mx-auto">
                        <ButtonPrimary
                          buttonClass="mt-40"
                          aria-label={tA11y('ek_global_icn-back_aria').ariaLabel}
                          buttonType={appButtonType.SECONDARY}
                          buttonContent={buttonContent}
                          iconLeft={appIconsPath.ARROW_BACK}
                          type="submit"
                        />
                      </div>
                    </div>
                    <FocusFirstError />
                  </Form>
                )}
              </Formik>
            </div>
          </AppPageContentWrapper>
        </div>
      </ScrollToTop>
    </>
  );
}

export default EditPrivateData;
